"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function LocaleDirective($compile, $parse, book, config, testFeatures) {
    'ngInject';
    return {
        restrict: 'AE',
        link: function (scope, elem, attrs) {
            Object.assign(scope, book);
            scope.ui = Object.assign({}, config.localeJson.ui);
            scope.hasFeature = testFeatures.hasFeature.bind(testFeatures);
            elem.append($compile('<span>' + $parse(attrs.value)(scope) + '</span>')(scope));
        }
    };
}
exports.LocaleDirective = LocaleDirective;
exports.default = angular.module('pb.locale', [])
    .directive('pbLocale', LocaleDirective);
